<template>
  <div class="ZhStatic">
    <div class="ZhStatic_title">
      <el-divider>统计数据</el-divider>
    </div>
    <div class="ZhStatic_charts">
      <div id="NDZWXL" style="height: 500px;"></div>
    </div>
    <div class="ZhStatic_charts">
      <div id="NDJJZZWXL" style="height: 500px;"></div>
      <p>注：比率=当年基金资助文献量/当年发文量*100%</p>
    </div>
    <div id="LMDFB" style="height: 500px;"></div>
    <div id="XKFB" style="height: 500px;"></div>
    <div id="GJCFB" style="height: 500px;"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { mapGetters } from "vuex";
import {
  getArticleTopicNameStatistic,
  getArticleKeywordStatistic,
  getArticleColumnDistribution,
  getArticleCountByYear,
  GetfundArticleCount
} from "@/api/emailPush";
export default {
  name: "ZhStatic",
  computed: {
    ...mapGetters({
      magId: "magId"
    })
  },
  created() {
    this.getArticleTopicNameStatistic(38);
    this.getArticleKeywordStatistic(39);
    this.getArticleColumnDistribution();
    this.getArticleCountByYear();
    this.getfundArticleCount();
  },
  methods: {
    // 年度基金资助文献量
    getfundArticleCount() {
      let params = {
        magId: this.magId
      };
      GetfundArticleCount(params).then(res => {
        if (res.data && res.data.data) {
          this.fundChart("NDJJZZWXL", res.data.data);
        }
      });
    },
    fundChart(id, data) {
      var chartDom = document.getElementById(id);
      var myChart = echarts.init(chartDom);
      var option;
      data.forEach(item => {
        item.bl = ((item.fundCount / item.totalCount) * 100).toFixed(2);
      });
      let lData = data.map(item => item.fundCount)
      let rData = data.map(item => item.bl)
      let lMax = Number(Math.max(...lData))
      let lMin = Number(Math.min(...lData))
      let rMax = Number(Math.max(...rData))
      let rMin = Number(Math.min(...rData))
      lMax = Math.ceil(lMax / 100) * 100
      lMin = Math.floor(lMin / 100) * 100
      rMax = Math.ceil(rMax / 10) * 10
      rMin = Math.floor(rMin / 10) * 10
      let splitNumber = 4
      let lInterval = lMax / splitNumber
      let rInterval = rMax / splitNumber

      option = {
        title: {
          text: "年度基金资助文献量",
          textStyle: {
            color: "#666", // 设置标题的颜色为 #4874CB
            fontSize: 16 // 设置标题的字体大小为 24px
          },
          x: "center" // 设置标题居中
        },
        grid: {
          top: "20%" // 设置顶部留白为20%
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
            crossStyle: {
              color: "#999"
            }
          },
          formatter: function(params) {
            // 获取年份
            let year = params[0].axisValueLabel;

            let tooltipText = `${year} <br>`; // 显示年份
            tooltipText += params
              .map(param => {
                // 判断数据系列来格式化显示单位
                if (param.seriesName === "基金资助文献量") {
                  return `${param.seriesName}: ${param.value}`; // 基金资助文献量单位是“篇”
                } else if (param.seriesName === "占当年文献量的比率") {
                  return `${param.seriesName}: ${param.value} %`; // 占比单位是“%”
                }
                return "";
              })
              .join("<br>");

            return tooltipText;
          }
        },
        legend: {
          data: ["基金资助文献量", "占当年文献量的比率"],
          top: "10%"
        },
        xAxis: [
          {
            type: "category",
            data: data.map(item => item.year),
            axisPointer: {
              type: "shadow"
            },
            axisLabel: {
              show: true, // 显示 X 轴标签
              rotate: 30 // 标签旋转角度，可以根据需要调整
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "文献量（篇）",
            splitNumber:splitNumber,
            // min: lMin,
            max: lMax,
            interval: lInterval,
            axisLabel: {
              formatter: "{value}"
            },
            splitLine: {
              // show: false // 不显示横轴背景线
            },
            // alignTicks: true,
          },
          {
            type: "value",
            name: "比率（%）",
            splitNumber:splitNumber,
            // min: rMin,
            max: rMax,
            interval: rInterval,
            axisLabel: {
              formatter: "{value}"
            },
            splitLine: {
              // show: false // 不显示横轴背景线
            },
            // alignTicks: true,
            // position: "right" // 右侧 y 轴
          }
        ],
        series: [
          {
            name: "基金资助文献量",
            type: "bar",
            color: "#4682B4",
            label: {
              show: true,
              position: "top"
            },
            barWidth: 20,
            data: lData
          },
          {
            name: "占当年文献量的比率",
            type: "line",
            yAxisIndex: 1,
            color: "#6AF9C4",
            data: rData
          }
        ]
      };

      option && myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    // 图38数据
    getArticleTopicNameStatistic(id) {
      return new Promise((resolve, reject) => {
        let params = {
          magId: this.magId,
          countYear: 10
        };
        getArticleTopicNameStatistic(params).then(res => {
          const { data } = res.data;
          let list = data.content.map(item => {
            return {
              name: item.topicName + "，" + item.count,
              value: item.count
            };
          });
          this.circularChart34("XKFB", list, ["40%", "70%"]);
          resolve();
        });
      });
    },
    // 图39数据
    getArticleKeywordStatistic(id) {
      return new Promise((resolve, reject) => {
        let params = {
          magId: this.magId,
          countYear: 10
        };
        getArticleKeywordStatistic(params).then(res => {
          const { data } = res.data;
          let titleArr = [];
          let countArr = [];
          data.content.forEach(item => {
            titleArr.push(item.keyword);
            countArr.push(item.count);
          });
          this.colChart25(
            "GJCFB",
            titleArr,
            countArr,
            "期刊近十年文献的关键词分布"
          );
          resolve();
        });
      });
    },
    getArticleColumnDistribution(id) {
      return new Promise((resolve, reject) => {
        let params = {
          magId: this.magId,
          countYear: 10
        };
        getArticleColumnDistribution(params).then(res => {
          const { data } = res.data;
          let titleArr = [];
          let countArr = [];
          data.content.forEach(item => {
            titleArr.push(item.columName);
            countArr.push(item.countArticle);
          });
          this.colChart25(
            "LMDFB",
            titleArr,
            countArr,
            "期刊近十年文献所属栏目的分布"
          );
          resolve();
        });
      });
    },
    getArticleCountByYear(id) {
      return new Promise((resolve, reject) => {
        let params = {
          magId: this.magId,
          page: 0,
          size: 20
        };
        getArticleCountByYear(params).then(res => {
          const { data } = res.data;
          this.lineChart36("NDZWXL", data.content.reverse());
          resolve();
        });
      });
    },
    lineChart36(id, data) {
      var chartDom = document.getElementById(id);
      var myChart = echarts.init(chartDom);
      var option;
      let name = data.map(item => item.year);

      // 计算左右 Y 轴数据的最大值和最小值
      const data1 = data.map(item => item.count || 0); // 文献量
      const data2 = data.map(item => item.citCount || 0); // 被引量

      // 计算最大值的辅助函数（不让最大值刚好到坐标轴最顶部）
      const getMaxValue = (arr) => {
        const max = Math.max(...arr);
        return Math.ceil(max / 9.5) * 10;
      };

      // 计算最小值的辅助函数（不让最小值刚好到坐标轴最底部）
      const getMinValue = (arr) => {
        const min = Math.min(...arr);
        return Math.floor(min / 12) * 10;
      };

      const min1 = getMinValue(data1);
      const max1 = getMaxValue(data1);
      const min2 = getMinValue(data2);
      const max2 = getMaxValue(data2);

      // 设置相同的分割段数
      const splitNumber = 5;
      const interval1 = (max1 - min1) / splitNumber;
      const interval2 = (max2 - min2) / splitNumber;

      option = {
        title: {
          text: "年度总文献量",
          textStyle: {
            color: "#666", // 设置标题的颜色为 #4874CB
            fontSize: 16 // 设置标题的字体大小为 24px
          },
          x: "center" // 设置标题居中
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["文献量", "被引量"],
          top: 30
        },
        grid: {
          left: "8%",
          right: "8%",
          bottom: "3%",
          top: "15%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: name,
          boundaryGap: true, //双侧留白
          axisLabel: {
            show: true, // 显示 X 轴标签
            rotate: 30 // 标签旋转角度，可以根据需要调整
          },
          axisPointer: {
            show: true, // 显示 X 轴指示器
            type: "shadow" // 指示器类型
          }
        },
        yAxis: [
          {
            type: "value",
            name: "文献量（篇）",
            position: "left",
            min: min1,
            max: max1,
            splitNumber: splitNumber,
            interval: interval1,
            axisLine: { show: false }, // 隐藏 y 轴线
            splitLine: { show: true } // 显示网格线
          },
          {
            type: "value",
            name: "被引量（次）",
            position: "right",
            min: min2,
            max: max2,
            splitNumber: splitNumber,
            interval: interval2,
            axisLine: { show: false }, // 隐藏 y 轴线
            splitLine: { show: false } // 隐藏网格线，避免重复横线
          }
        ],
        series: [
          {
            name: "文献量",
            type: "line",
            yAxisIndex: 0,
            data: data.map(item => item.count),
            itemStyle: { normal: { label: { show: true } } },
            color: "#4682B4"
          },
          {
            name: "被引量",
            type: "line",
            yAxisIndex: 1,
            data: data.map(item => item.citCount || 0),
            itemStyle: { normal: { label: { show: true } } },
            color: "#ee7d04"
          }
        ]
      };

      option && myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    colChart25(id, titleArr, countArr, title) {
      if (!document.getElementById(id)) {
        return;
      }
      const myChart = echarts.init(document.getElementById(id));
      myChart.setOption(
        {
          title: {
            text: title,
            textStyle: {
              color: "#666", // 设置标题的颜色为 #4874CB
              fontSize: 16 // 设置标题的字体大小为 24px
            },
            x: "center" // 设置标题居中
          },
          color: "#4682B4",
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "none",
              crossStyle: {
                color: "#999"
              }
            }
          },
          xAxis: [
            {
              type: "category",
              data: titleArr,
              axisPointer: {
                type: "shadow"
              },
              axisLabel: {
                rotate: 35,
                formatter: value => {
                  var res = value;
                  if (res.length > 20) {
                    res = res.substring(0, 20) + "..";
                  }
                  return res;
                }
              }
            }
          ],
          grid: {
            left: "10%",
            bottom: "30%",
            top: "10%"
          },
          yAxis: [
            {
              type: "value",
              name: "文献量（篇）",
              minInterval: 1,
              splitLine: {
                // show: false // 不显示横轴背景线
              }
            }
          ],
          series: [
            {
              name: "文献量",
              type: "bar",
              data: countArr,
              label: {
                show: true,
                position: "top"
              },
              barWidth: 20
            }
          ]
        },
        true
      );
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    circularChart34(id, data, radius = "70%") {
      var chartDom = document.getElementById(id);
      var myChart = echarts.init(chartDom);
      let chartDataName = data.map(item => item.name);
      var option;
     option = {
  title: {
    text: "期刊近十年文献的学科分布",
    textStyle: {
      color: "#666",
      fontSize: 16
    },
    x: "center"
  },
  grid: {
    bottom: "0%"
  },
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}"
  },
  legend: {
    type: "scroll",  // 使 legend 可以滚动
    orient: "vertical",
    right: 20,
    top: 20,
    bottom: 20,
    data: chartDataName,
    formatter: function(name) {
      return name.length > 10 ? name.substring(0, 10) + "..." : name;
    },
    itemWidth: 10,
    itemHeight: 10
  },
  series: [
    {
      type: "pie",
      name: "",
      radius: "70%",
      center: ["50%", "50%"],
      data: data.map((item, index) => {
        if (index < 15) {
          item.labelLine = {
            length: 10,
            smooth: true
          };
          item.label = {
            show: true // 显示名称
          };
          item.emphasis = {
            labelLine: {
              show: true // 鼠标悬停时显示飞线
            },
            label: {
              show: true // 鼠标悬停时显示名称
            }
          };
        } else {
          item.labelLine = {
            show: false // 不显示飞线
          };
          item.label = {
            show: false // 不显示名称
          };
          item.emphasis = {
            labelLine: {
              show: false // 鼠标悬停时也不显示飞线
            },
            label: {
              show: false // 鼠标悬停时也不显示名称
            }
          };
        }
        return item;
      }),
    }
  ]
};




      option && myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.ZhStatic {
  padding-top: 20px;
  &_charts {
    text-align: left;
    p {
      margin-left: 10%;
      color: #666;
      font-weight: bolder;
    }
  }
  &_title {
    width: 400px;
    margin: 0 auto;
    /deep/ .el-divider__text {
      font-size: 30px;
      font-weight: bolder;
    }
    /deep/ .el-divider--horizontal {
      margin: 18px 0;
    }
    p {
      color: #999;
    }
  }
  > div {
    margin-bottom: 50px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
